

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://d54f412891ca4f7e95ff0c85a6f62269@sentry-next.wixpress.com/1128", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/9b222164c6be38e0/packages/communities-forum-member-pages/src/components/MemberPosts/Widget/index.tsx';
    import createController from '/home/builduser/work/9b222164c6be38e0/packages/communities-forum-member-pages/src/components/MemberPosts/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    
var initI18n = null;

    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
var I18nextProvider = React.Fragment;


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'MemberPosts';
    var projectName = 'communities-forum-member-pages';
    var sentryConfig = {
      DSN: 'https://d54f412891ca4f7e95ff0c85a6f62269@sentry-next.wixpress.com/1128',
      id: 'd54f412891ca4f7e95ff0c85a6f62269',
      projectName: 'communities-forum-member-pages',
      teamName: 'wix-forum',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/9b222164c6be38e0/packages/communities-forum-member-pages/src/components/MemberPosts/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"centralized":true,"scopes":["wix-forum","ricos"]};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":false,"icuEnabled":false};
    var defaultTranslations = null;
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "14724f35-6794-cd1a-0244-25fd138f9242";
    var componentId = "14f0266c-e0a3-afc6-d07c-5be8e20949cd";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = true;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/9b222164c6be38e0/packages/communities-forum-member-pages/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
